
import { useEffect } from 'react';
import { FacebookPixel } from '@/lib/facebookPixel';

export const useFacebookPixel = () => {
  useEffect(() => {
    FacebookPixel.init();
  }, []);

  return {
    trackSignUp: FacebookPixel.trackSignUp,
    trackPurchaseInitiated: FacebookPixel.trackPurchaseInitiated,
    trackPurchase: FacebookPixel.trackPurchase,
    trackEvent: FacebookPixel.trackEvent,
    trackCustomEvent: FacebookPixel.trackCustomEvent,
  };
};
